import './global.js'

import * as Helper from './classes/Helpers';
import * as Counter from './classes/Counter';
import AjaxLoadMore from "./classes/AjaxLoadMore";
import HeroAnimations from "./classes/HeroAnimations";
import challengesAnimation from "./classes/challengesAnimation";
import {scrollToHash, getAnchor, toggleStickyMenu} from "./classes/AnchorScroll.js";
import {changeMenuActiveColor} from "./classes/SideMenuAnimation.js";
import sideMenuInit from "./classes/SideMenuAnimation.js";
import contentWithEyeAnimInit from "./classes/ContentWithEyeAnim.js";
import productHeroSliderInit from "./classes/ProductHero.js";
import DevicesFilter from "./classes/DevicesFilter.js";

const numberBox = [...document.querySelectorAll('.hero-counter')];
const sectionStickyMenu = [...document.querySelectorAll('.sticky-wrap')];
const sectionWithShowMoreText = [...document.querySelectorAll('.section-press-kit')];
const sectionTeamGpx = [...document.querySelectorAll('.section-team-gpx')];
const sectionMainTitles = [...document.querySelectorAll('.section-title--main')];
const itemAnimationFade = [...document.querySelectorAll('.item-animation--fade')];
const sectionsWithBg = [...document.querySelectorAll('section[class*="bg-"]'), ...document.querySelectorAll('.anim-menu__panels')];
const showMoreBtns = [...document.querySelectorAll('.btn-show-more')];

// Hero Animations
if(document.getElementById('hero-animations')) HeroAnimations.init('hero-animations');

$(document).ready(function ($) {
    Helper.MobileNav();
    Helper.OpenClose();
    Helper.Tabs();
    Helper.initSwiper();
    Helper.MobileSwiper();
    Helper.Modal();
    Helper.InputFocus();
    Helper.ModalVideo();
    Helper.ProgressBar();
    Helper.CountDown();
    Helper.LeadFormValidator();
    Helper.TOC();
    Helper.WpImageWidth();
    (new AjaxLoadMore());
    Helper.updatePartnersSliderWidth();
    Helper.tooltipAnimation();
    Helper.industriesCardsContentHeight();
    if (numberBox) Counter.initAnimation(numberBox, Counter.counterInit);
    if (sectionStickyMenu) toggleStickyMenu(sectionStickyMenu);
    if (sectionWithShowMoreText) Helper.toggleShowMore(sectionWithShowMoreText);
    if (sectionTeamGpx) Helper.teamSectionAnimations(sectionTeamGpx);
    if (sectionMainTitles) sectionMainTitles.forEach( title => Helper.fadeUpAnimation(title, title, "top 80%", 1, 0.3, 100));
    if (itemAnimationFade) itemAnimationFade.forEach( item => Helper.fadeAnimation(item, item, "top 80%", 1, 0.4, 0.3));

    // Challenges Animation
    if(document.getElementById('challenges')) challengesAnimation.init();

    new sideMenuInit();
    new contentWithEyeAnimInit();
    new DevicesFilter();
    new productHeroSliderInit();


    Helper.parallaxOverlapAnimation();

    showMoreBtns.forEach(item => item.addEventListener('click', () => Helper.showMoreWithGrid(item)));

    Helper.focusLabelAnimation();
    Helper.showCTABottomButton();
});

window.onload = () => {
  scrollToHash(window.location.hash);
};

window.addEventListener('click', (e) => {
    if (e.target.hash) scrollToHash(getAnchor(e.target), e);
});

window.addEventListener('resize', () => {
    setTimeout(() => {
        Helper.updatePartnersSliderWidth();
    }, 300);
});

window.addEventListener('scroll', () => {
    if(sectionsWithBg) changeMenuActiveColor(sectionsWithBg);
})

setTimeout(()=>document.querySelector('body').classList.remove('remove-animation'), 100) // prevent keyframe animations on the page load